// Angular
import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders } from '@angular/common/http';
// CRUD
import { QueryResultsModel } from '../models/query-models/query-results.model';
import { QueryParamsModel } from '../models/query-models/query-params.model';
import { HttpExtenstionsModel } from '../../crud/models/http-extentsions-model';
import { TokenStorage } from '../../../../core/auth/_services/token-storage.service';
import { Router } from '@angular/router';

@Injectable()
export class HttpUtilsService {
	/**
	 * Prepare query http params
	 * @param queryParams: QueryParamsModel
	 */
    constructor(private tokenStorage: TokenStorage, private router: Router) {
	}
    getFindHTTPParams(queryParams): HttpParams {
        //console.log(queryParams.filter);
		let params = new HttpParams()
        //.set('filter',  queryParams.filter )
        .set('sortOrder', queryParams.sortOrder)
        .set('sortField', queryParams.sortField)
        .set('page', (queryParams.pageNumber + 1).toString())
        .set('record', queryParams.pageSize.toString());
        let keys = [], values = [];
        if (queryParams.more) {
            params = params.append('more', 'true');
        }
        Object.keys(queryParams.filter).forEach(function (key) {
            if (typeof queryParams.filter[key] !== 'string' || queryParams.filter[key] !== '') {
                keys.push(key);
                values.push(queryParams.filter[key]);
            }
        });
        if (keys.length > 0) {
            params = params.append('filter.keys', keys.join('|'))
                .append('filter.vals', values.join('|'));
        }
        let grp_keys = [], grp_values = [];
        Object.keys(queryParams.filterGroup).forEach(function (key) {
            if (typeof queryParams.filterGroup[key] !== 'string' || queryParams.filterGroup[key] !== '') {
                grp_keys.push(key);
                let value_str="";
                if(queryParams.filterGroup[key]&&queryParams.filterGroup[key].length>0){
                    value_str =  queryParams.filterGroup[key].join(',')
                }
                grp_values.push(value_str);
            }
        });
        if (grp_keys.length > 0) {
            params = params.append('filterGroup.keys', grp_keys.join('|'))
                .append('filterGroup.vals', grp_values.join('|'));
        }
        //console.log("param", params);
        return params;
    }
	/**
	 * Prepare query http params QLPA
	 * @param queryParams: QueryParamsModel
	 */
    getFindHTTPParamsQLPA(queryParams): HttpParams {
        let params = new HttpParams()
            .set('sortOrder', queryParams.sortOrder)
            .set('OrderBy', queryParams.sortField)
            .set('page', (queryParams.pageNumber + 1).toString())
            .set('record', queryParams.pageSize.toString());
        let keys = Object.keys(queryParams.filter);
        for (var i = 0; i < keys.length; i++) {
            params = params.set(keys[i], queryParams.filter[keys[i]]);
        }
        return params;
    }

	/**
	 * get standard content-type
	 */
    getHTTPHeaders(isFormData? : boolean): HttpHeaders {
        var _token = '';
        this.tokenStorage.getAccessToken().subscribe(t => { _token = t; });
		let result = new HttpHeaders({
			'Authorization': 'Bearer ' + _token,
		});
		if (!isFormData) {
			result.append("Content-Type", "application/json");
        }
        
        if(!_token){
            this.router.navigate(['/login']);
            return result;
        }
		return result;
    }

    baseFilter(_entities: any[], _queryParams: QueryParamsModel, _filtrationFields: string[] = []): QueryResultsModel {
        const httpExtention = new HttpExtenstionsModel();
        return httpExtention.baseFilter(_entities, _queryParams, _filtrationFields);
    }

    sortArray(_incomingArray: any[], _sortField: string = '', _sortOrder: string = 'asc'): any[] {
        const httpExtention = new HttpExtenstionsModel();
        return httpExtention.sortArray(_incomingArray, _sortField, _sortOrder);
    }

    searchInArray(_incomingArray: any[], _queryObj: any, _filtrationFields: string[] = []): any[] {
        const httpExtention = new HttpExtenstionsModel();
        return httpExtention.searchInArray(_incomingArray, _queryObj, _filtrationFields);
    }
}
